import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const words = ["Reputation.", "Relevance.", "Influence."];

export const Showreel = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0.05, 0.42], [0.72, 1]);
  const radius = useTransform(scrollYProgress, [0.05, 0.42], [64, 0]);
  const barScale = useTransform(scrollYProgress, [0.3, 0.88], [0, 1]);
  const opacities = [
    useTransform(scrollYProgress, [0.3, 0.4, 0.5, 0.58], [0, 1, 1, 0]),
    useTransform(scrollYProgress, [0.5, 0.58, 0.66, 0.74], [0, 1, 1, 0]),
    useTransform(scrollYProgress, [0.66, 0.74, 0.88], [0, 1, 1]),
  ];

  return (
    <section ref={ref} className="relative h-[280vh]" data-testid="showreel-section">
      <div className="sticky top-0 z-[60] flex h-screen items-center justify-center overflow-hidden">
        <motion.div
          style={{ scale, borderRadius: radius }}
          className="relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-[#101013] text-[#F5F2EC]"
        >
          <p
            className="absolute left-6 top-8 text-[10px] uppercase tracking-[0.35em] text-[#F5F2EC]/50 sm:left-12"
            data-testid="showreel-label"
          >
            The Showreel — Influence in Motion
          </p>
          <p className="absolute bottom-8 right-6 text-[10px] uppercase tracking-[0.35em] text-[#F5F2EC]/50 sm:right-12">
            MMXXVI
          </p>
          <div className="relative h-full w-full">
            {words.map((w, i) => (
              <motion.span
                key={w}
                style={{ opacity: opacities[i] }}
                className="absolute inset-0 flex items-center justify-center px-6 pt-16 text-center font-syne text-3xl font-extrabold uppercase tracking-wider sm:text-5xl lg:text-6xl"
                data-testid={`showreel-word-${i}`}
              >
                {w}
              </motion.span>
            ))}
          </div>
          <motion.div style={{ scaleX: barScale }} className="absolute bottom-0 left-0 h-1 w-full origin-left bg-primary" />
        </motion.div>
      </div>
    </section>
  );
};
